import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'

//components
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { SelectButton } from 'primereact/selectbutton'
import { Button } from 'primereact/button'
import DeletePrompt from '../Prompt/components/DeletePrompt'
import { Toast } from 'primereact/toast'

//api
import { PromptService } from '../../service/prompt-service'

const PromptDetail = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [prompt, setPrompt] = useState()
  const [selectButtonValue, setSelectButtonValue] = useState('')
  const toast = useRef(null)
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  const options = ['Default', 'Sistema']

  //chiamata GET
  useEffect(() => {
    const fetchPrompt = () => {
      PromptService.getPrompt(id, (data) => {
        setPrompt(data)
        setValue('name', data.name)
        setValue('content', data.content)
        setSelectButtonValue(data.is_default ? 'Default' : 'Sistema')
      })
    }
    fetchPrompt()
  }, [id])

  //chiamata PUT
  const onSubmit = (data) => {
    const isDefault = selectButtonValue === 'Default'
    const isSystem = selectButtonValue === 'Sistema'

    const payload = {
      name: data.name,
      content: data.content,
      is_default: isDefault,
      is_system: isSystem,
    }

    PromptService.updatePrompt(id, payload, (response) => {
      toast.current.show({
        severity: 'success',
        summary: 'Modifica',
        detail: 'Prompt modificato!',
      })
      navigate('/dashboard/prompt')
    })
  }

  return (
    <div>
      <h1>Gestione: {prompt?.name}</h1>
      <div className="prompt__Wrapper">
        <h3>Modifica Prompt</h3>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <div className="prompt__InputWrapper">
              <label>Nome Prompt</label>
              <InputText
                id="name"
                {...register('name', {
                  required: 'Campo obbligatorio',
                })}
                className={errors.name ? 'p-invalid' : ''}
              />
              {errors.name && (
                <small className="p-error">{errors.name.message}</small>
              )}
            </div>
            <div className="prompt__InputWrapper">
              <label>Prompt</label>
              <InputTextarea
                {...register('content', {
                  required: 'Campo obbligatorio',
                })}
                rows={10}
                cols={30}
                className={errors.content ? 'p-invalid' : ''}
              />
            </div>
            <div className="prompt__InputWrapper">
              <label>Tipo di Prompt</label>
              <SelectButton
                value={selectButtonValue}
                onChange={(e) => setSelectButtonValue(e.value)}
                options={options}
                className="prompt__SpacedButtons"
              />
            </div>
            <div className="prompt__ButtonWrapper">
              <div>
                <Toast ref={toast} />
                <Button type="Submit">Salva</Button>
              </div>
              <DeletePrompt promptId={id} />
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default PromptDetail
